import { render } from "./InventorySearch.vue?vue&type=template&id=bf2c525c&scoped=true"
import script from "./InventorySearch.vue?vue&type=script&lang=ts"
export * from "./InventorySearch.vue?vue&type=script&lang=ts"

import "./InventorySearch.vue?vue&type=style&index=0&id=bf2c525c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bf2c525c"

export default script